import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import TabPanel from '@mui/lab/TabPanel';
import SearchBar from "@mkyy/mui-search-bar";
import { toast } from "react-toastify";
import UsersTable from '../../../common/Tables/UsersTable';
import { privateAPI } from '../../../utils/api';

const ApproveUsers = () => {
  const [loading, setLoading] = useState(true);
  const [allUsers, setAllUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");

  const requestSearch = (searchedVal) => {
    const filteredRows = allUsers.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setRows(filteredRows);
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const getAllUsers = async () => {
    setLoading(true);

    try{
        const response = await privateAPI.get(`/auth/bacchus/admin/users?status=READY_FOR_REVIEW`);
        setAllUsers(response.data);
        setRows(response.data);
        setLoading(false);
    } catch (error){
        setLoading(false);
        if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  const approveUser = async (id, updateStatus) => {
    setLoading(true);

    try{
      const response = await privateAPI.get(`/auth/bacchus/client/user/${id}`);
      const userDTO = response.data
      userDTO.status = updateStatus;
      await privateAPI.put(`/auth/bacchus/admin/user/status/${userDTO.id}`, userDTO);
      getAllUsers();
      setLoading(false);
    } catch (error){
      setLoading(false);
      if(error.request.status === 500) return toast.error('Internal server error')
    }
  }

  useEffect(() => {
    getAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TabPanel value="4">
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        style={{ marginBottom: '30px', border: '1px solid #001753', boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)' }}
        />
      <UsersTable 
        items={rows}
        approveUsers={true}
        approveUser={approveUser}
        />
      <Backdrop
        sx={{ color: '#fff', zIndex: 1000 }}
        open={loading}
        >
          <CircularProgress color="inherit" />
      </Backdrop>
    </TabPanel>
  );
};

export default ApproveUsers;
